import * as React from 'react';
import { useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';

import { Alert, IconButton, Box } from '@material-ui/core';
import useGetMOTD from '../hooks/useGetMOTD';

export default function AnnouncementBanner(props) {
  const [open, setOpen] = useState(true);
  const { message: motdMessage } = useGetMOTD();

  const handleClose = (reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpen(false);
  };

  return open ? (
    <Box data-testid="announcement_banner" sx={{ paddingTop: 2, paddingX: 3 }}>
      <Alert
        {...props}
        action={
          <IconButton
            data-testid="close_banner"
            size="small"
            aria-label="close"
            color="inherit"
            onClick={handleClose}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        }
        severity="info"
        sx={{ width: '100%', marginLeft: 0 }}
      >
        {motdMessage}
      </Alert>
    </Box>
  ) : null;
}
